import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

const LandlordInfo = () => {
  const [landlord, setLandlord] = useState([]);
  const { user } = useAuth(); // get user from context

  const loadUsersDetails = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/tenancy-users`, {
        method: 'POST',
        headers: {'Content-Type' : 'application/json'},
        body: JSON.stringify({user_id: user.id})
      });
      const result = await response.json();
      
      if (response.ok) {
        setLandlord(result.find(person => person.role == "landlord"));
      } else {
        console.error(result.error);
      }
    } catch (error) {
      console.error('Error: ', error);
    }
  };

  useEffect(() => {
    if (user && user.id) {
      loadUsersDetails();
    }
  }, [user]);


  return (
    <div>
      <h1>Property Manager</h1>

      <section>
        <h3>Contact</h3>
        <p><strong>Name:</strong> {landlord.name}</p>
        <p><strong>Email:</strong> {landlord.email}</p>
        <p><strong>Email:</strong> {landlord.phone}</p>
      </section>
      <br></br>

      <section>
        <h3>Bank Details</h3>
        <p><strong>Bank:</strong> Barclays</p>
        <p><strong>Sort Code:</strong> 20-40-12</p>
        <p><strong>Account Number:</strong> 12345678</p>
      </section>
    </div>
  );
};

export default LandlordInfo;
